const e = {
  "pipeline-group-section__badge": "pipeline-group-section__badge",
  "pipeline-group-section__visually-hidden": "pipeline-group-section__visually-hidden"
};
export {
  e as default
};
